import type { Maybe } from "@regle/core"
import { withMessage } from "@regle/rules"
import type { Moment } from "moment"
import { isMidnight } from "@/helper/time-helper.ts"

/**
 * Validates that timeEnd is after timeStart.
 * When allowEqual is true, timeEnd may also be the same as timeStart.
 * When treatMidnightAsEndOfDay is true, a timeEnd at midnight is treated as end-of-day (supports full-day events).
 */
export function chronologicalStartAndEndTimeValidator({
  allowEqual = false,
  treatMidnightAsEndOfDay = false
} = {}) {
  return withMessage((value: Maybe<{ timeStart?: Moment | null; timeEnd?: Moment | null }>) => {
    if (!value?.timeStart || !value.timeEnd) {
      return true
    }

    const effectiveEnd =
      treatMidnightAsEndOfDay && isMidnight(value.timeEnd)
        ? value.timeEnd.clone().endOf("day")
        : value.timeEnd

    return allowEqual
      ? effectiveEnd.isSameOrAfter(value.timeStart)
      : effectiveEnd.isAfter(value.timeStart)
  }, "De eindtijd moet na de starttijd liggen.")
}
